import ExtractorSessionListApp from "extractorSession/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const extractorSessionRoute: RouteObject = {
  path: "extractorsession",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ExtractorSessionListApp,
  }]
};